import cx from 'classnames';
import { bool, string } from 'prop-types';
import { Button } from '@fff-web/fff-ui-shared';
import { trackExpiredReactivateStarted } from '../../../../utils/analytics';
import env from '../../../../utils/env';
import * as styles from './ReactivateCTA.module.scss';

const ReactivateCTA = ({
  title,
  desc = '',
  ctaLabel,
  isMobile,
  iconClass = '',
  baseClass,
  isClubTier = false,
  isCustomizationFlow = false,
  boxSlug = null,
}) => {
  const handleClickReactivate = (cta) => {
    trackExpiredReactivateStarted(cta).finally(() => {
      window.location = `${env.envURL}/${
        isClubTier ? 'activate-box-subscription' : 'reactivate-my-membership'
      }`;
    });
  };

  const handleClickCustomize = () =>
    (window.location = `${env.envURL}/customize-box${boxSlug ? `/${boxSlug}` : ''}`);

  const ctaAction = isCustomizationFlow ? handleClickCustomize : handleClickReactivate;

  return (
    <div
      data-testid="reactivate-cta"
      className={cx(styles.container, baseClass, {
        [styles.mobile]: isMobile,
      })}
    >
      <i
        className={cx(styles.icon, {
          [iconClass]: iconClass,
          [styles.shoppingBag]: !iconClass,
        })}
      />
      <h3 className={styles.title}>{title}</h3>
      {desc && <p className={styles.desc}>{desc}</p>}
      <Button
        className={styles.cta}
        data-testid={`${baseClass}-reactivate-cta`}
        onClick={() => {
          ctaAction();
        }}
      >
        {ctaLabel}
      </Button>
      <br />
    </div>
  );
};

ReactivateCTA.propTypes = {
  title: string.isRequired,
  desc: string,
  ctaLabel: string.isRequired,
  isMobile: bool.isRequired,
  iconClass: string,
  baseClass: string.isRequired,
  isClubTier: bool,
  isCustomizationFlow: bool,
  boxSlug: string,
};

export default ReactivateCTA;
